<script>
  export let d;
  export let viewBox;
  export let width;
</script>

<svg style:width class="letter" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" { viewBox }>
  <path { d } fill="none" stroke="Coral" stroke-width="30px" stroke-linecap="round" />
</svg>

<style>
  .letter {
    flex: 0 0 auto;
  }
</style>
